import {
  ApplicationConfig,
  isDevMode,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withExperimentalAutoCleanupInjectors} from '@angular/router';

import {routes} from '@routes/app.routes';
import {provideClientHydration, withHttpTransferCacheOptions} from '@angular/platform-browser';
import {provideServiceWorker} from '@angular/service-worker';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withExperimentalAutoCleanupInjectors()
    ),
    provideClientHydration(
      withHttpTransferCacheOptions({})
    ),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:10000'
    }),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),  // Keep your interceptors if you use any
    )
  ]
};

const siteConfig = {
  LASTFM_API_KEY: "9dad61e4552e68f25a22ef03d4b01db9",
};

export default siteConfig;
